var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item && _vm.item.length)?_c('sButton',{attrs:{"color":"var(--white-color)","data-qa":"start-analiz-ai","loading":_vm.loading,"type":"border"},on:{"click":_vm.startAnalizAI}},[_vm._v(" "+_vm._s(_vm.$t('AIRequirements.StartAnalizAI'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }